import React from 'react';
import Checkout from 'components/Domain/Checkout';
import Searchdomain from 'components/Domain/Search';
import Usedomain from 'components/Domain/UseDomain';
import EmptyState from 'components/Domain/EmptyDomain';
import PurchasedDomain from 'components/Domain/Purchased';

export enum DomainMenuType {
    Empty = 0,
    Purchased = 1,
    Checkout = 2,
    Search = 3,
    UseOwn = 4

}



export default function DomainMenus() {

    const [menuType, setMenuType] = React.useState(DomainMenuType.Purchased);
    



    return <>
{/*     <br/>
    <h6>Testing SSA Domain Settings</h6>
    <div className = "flex-row">
        <button onClick={()=>setMenuType(DomainMenuType.Empty)}>Main</button>
        <button onClick={()=>setMenuType(DomainMenuType.Purchased)}>Purchased</button>
        <button onClick={()=>setMenuType(DomainMenuType.Checkout)}>Checkout</button>
        <button onClick={()=>setMenuType(DomainMenuType.Search)}>Search</button>
        <button onClick={()=>setMenuType(DomainMenuType.UseOwn)}>UseOwn</button>
    </div> */}
    <RenderMenu menuType={menuType} setMenu={setMenuType}/>
    </>

}

function RenderMenu({ menuType,setMenu }: { menuType: DomainMenuType,setMenu:Function }) {


    switch (menuType) {

        case DomainMenuType.Empty:
            return <EmptyState/>
        case DomainMenuType.Search:
            return <Searchdomain inEditor = {true} setMenu={setMenu}/>
        case DomainMenuType.UseOwn:
            return <Usedomain inEditor = {true} setMenu={setMenu}/>
        case DomainMenuType.Purchased:
            return <PurchasedDomain inEditor = {true} setMenu={setMenu}/>
        case DomainMenuType.Checkout:
            return <Checkout inEditor = {true} setMenu={setMenu}/>

        default:
            return <></>
    }

}